import CityPageTemplate from "../city-template/CityPageTemplate";
import { erlangerConfig } from "./data";

export default function ErlangerPage() {
  return <CityPageTemplate config={erlangerConfig} />;
}